import React, { useEffect, useState } from "react";
import Breadcrump from "../../Components/Breadcrump";
import aboutUsApi from "../../api/aboutUsApi";
import { extractCmsDescription } from "../../utils/cmsUtils";

function AboutUs() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, []);

  const fetchCMSDetails = async () => {
    try {
      const res = await aboutUsApi.details();

      if (res.code === 200) {
        setTitle("About Us");
        setDescription(extractCmsDescription(res.data, "about-us"));
      }
    } catch (err) {
      console.error("About Us API Error:", err);
    }
  };

  return (
    <>
      <Breadcrump title="about-us" />

      <section className="py-5">
        <div className="container">
          <div className="content text-dark">
            {description ? (
              <div
                dangerouslySetInnerHTML={{ __html: description }}
                style={{ color: "#000", fontSize: "16px" }}
              />
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
